import { Component, ViewChild } from '@angular/core';
//import { HighchartsChartModule } from 'highcharts-angular';
import { CrossoverService } from 'src/app/services/crossover.service';
import * as Highcharts from 'highcharts';
import { Subscription } from 'rxjs';
import { TradingSystemSummary } from 'src/app/models/trading-system-summary';
import { TradingSystemGraficoWeeklyComponent } from '../../shared/trading-system-grafico-weekly/trading-system-grafico-weekly.component';
import { HighchartsChartModule } from 'highcharts-angular';
import { TradingSystemSummaryComponent } from '../../shared/trading-system-summary/trading-system-summary.component';

@Component({
  selector: 'app-xau',
  standalone: true,
  imports: [HighchartsChartModule, TradingSystemGraficoWeeklyComponent,
    TradingSystemGraficoWeeklyComponent, TradingSystemSummaryComponent
  ],
  templateUrl: './xau.component.html',
  styleUrl: './xau.component.scss'
})
export class XauComponent {
  chartConstructor: string = 'chart';
  Highcharts: typeof Highcharts = Highcharts;
  updateFlag: boolean = false; // optional boolean
  oneToOneFlag: boolean = true; // optional boolean, defaults to false
  runOutsideAngular: boolean = false; // optional boolean, defaults to false
  runOutsideAngularFlag = false; // optional boolean, defaults to false
  chartOptions: Highcharts.Options = {}
  chartOptions2: Highcharts.Options = {}

  subServ: Subscription | null = null
  subServ2: Subscription | null = null
  ts: TradingSystemSummary = new TradingSystemSummary()
  @ViewChild('chartWeek') chartWeek!: TradingSystemGraficoWeeklyComponent
  @ViewChild('chartBuy') chartWeekBuy!: TradingSystemGraficoWeeklyComponent
  @ViewChild('chartSell') chartWeekSell!: TradingSystemGraficoWeeklyComponent
  @ViewChild('chartMonth') chartMonth!: TradingSystemGraficoWeeklyComponent
  @ViewChild('chartMonthlyBuy') chartMonthlyBuy!: TradingSystemGraficoWeeklyComponent
  @ViewChild('chartMonthlySell') chartMonthSell!: TradingSystemGraficoWeeklyComponent

  constructor(private serv: CrossoverService) { }

  ngOnInit() {
    this.subServ = this.serv.xauM15().subscribe((data: any) => {
      if (data.res == 'ok') {
        let s1 = data.data.map((el: any) => {
          return [el.ora, parseFloat(el.vclose)]
        })
        let s2 = data.data.map((el: any) => {
          return [el.ora, parseFloat(el.usd)]
        })
        let media = data.data.map((el:any) => el.vclose).splice(0,100)
        let s3 = data.data.map((el: any) => {
          media.push(el.vclose)
          media.slice(1)
          return [el.ora, media.reduce((a: any, b: any) => parseFloat(a) + parseFloat(b)) / media.length]
        })
        this.graficoXAUM15(s1, s2, s3)
      }
    })
    this.subServ2 = this.serv.xauM15_BT().subscribe((data: any) => {
      console.log(data)
      if(data.res=='ok'){
        let s1 = data.data.map((el: any) => {
          return [el.ora, parseFloat(el.prezzoclose)]
        })
        let s2 = data.data.map((el: any) => {
          return [el.ora, parseFloat(el.profit)]
        })
        let progr = 0
        let s3 = data.data.map((el: any) => {
          progr += parseFloat(el.profit)
          return [el.ora, progr]
        })
        this.graficoBT(s1, s2, s3)
        let ts1 = data.data.map((el: any) => {
          return {
            verso: el.verso,
            punti: parseFloat(el.profit)
          }
        })
        this.ts.popolaDati('XAUUSD', 0.1, ts1)
        data.data.map((el: any) => { el.ora = el.oraclose })
        this.chartWeek.caricaDati(data.data)
        this.chartWeekBuy.caricaDati(data.data.filter((el: any) => el.verso == 'buy'))
        this.chartWeekSell.caricaDati(data.data.filter((el: any) => el.verso == 'sell'))
        this.chartMonth.caricaDatiMese(data.data)
        this.chartMonthlyBuy.caricaDatiMese(data.data.filter((el: any) => el.verso == 'buy'))
        this.chartMonthSell.caricaDatiMese(data.data.filter((el: any) => el.verso == 'sell'))
      }
    })
  }

  graficoBT(s1: any, s2: any, s3: any) {
    let ser: Highcharts.SeriesOptionsType[] = [
      {name: 'Close', type: 'line', data: s1, color: 'lightgreen',turboThreshold: 2000},
      {name: 'Progressivo', type: 'line', data: s3, color: 'red',turboThreshold: 2000, yAxis: 2},
    ]
    this.chartOptions2 = {
      title: { text: 'XAUUSD M15' },
      chart: {
        zooming: {
          type: 'x'
        },
        /* style: {
          cursor: 'crosshair'
        } */
      },
      series: ser,
      yAxis: [
        {
          plotLines: [{
            value: 0,
            width: 2,
            color: 'black',
            zIndex: 4
          }],
        },
        {
          title: { text: 'XAUUSD' }
        },
        {
          title: { text: 'Progressivo' },
          opposite: true
        },
      ]
    }
  }
  
  graficoXAUM15(s1: any, s2: any, s3: any) {
    let ser: Highcharts.SeriesOptionsType[] = [
      {name: 'Cross USD', type: 'line', data: s2, color: 'orange', dashStyle: 'LongDash'},
      {name: 'XAUUSD', type: 'line', data: s1, yAxis: 2, color: 'lightgreen'},
      {name: 'Media 100', type: 'line', data: s3, yAxis: 2, color: 'red', dashStyle: 'ShortDashDot'},
    ]
    this.chartOptions = {
      title: { text: 'XAUUSD M15' },
      chart: {
        zooming: {
          type: 'x'
        },
        /* style: {
          cursor: 'crosshair'
        } */
      },
      series: ser,
      yAxis: [
        {
          plotLines: [{
            value: 0,
            width: 2,
            color: 'black',
            zIndex: 4
          }],
        },
        {
          title: { text: 'Cross USD' }
        },
        {
          title: { text: 'XAUUSD' },
          opposite: true
        },
        {
          title: { text: 'Media 100' },
          opposite: true
        },
      ]
    }
  }

  ngOnDestroy() {
    if (this.subServ) {
      this.subServ.unsubscribe()
    }
    if(this.subServ2){
      this.subServ2.unsubscribe()
    }
  }
}
